export let CollapsiblePanelCssVars = /*#__PURE__*/function (CollapsiblePanelCssVars) {
  /**
   * The collapsible panel's height.
   * @type {number}
   */
  CollapsiblePanelCssVars["collapsiblePanelHeight"] = "--collapsible-panel-height";
  /**
   * The collapsible panel's width.
   * @type {number}
   */
  CollapsiblePanelCssVars["collapsiblePanelWidth"] = "--collapsible-panel-width";
  return CollapsiblePanelCssVars;
}({});